module.exports = __webpack_public_path__ + "static/banner-articles-cd6ce03770b35d2b45ea541df80d8573.jpg";